export default "__VITE_ASSET__otuCM44U__"